<!-- 院内处方流转1.0新增组件 -->
<template>
  <div>
    <div class="case-list" v-if="caseList && caseList.length > 0">
      <van-list v-model="loading" :finished="finished">
        <case-item v-for="(item, key) in caseList" :medicalRecord="item" :key="key" />
      </van-list>
    </div>
    <van-empty
      class="flex center height100"
      v-else-if="caseList && caseList.length == 0"
      :image="require('@/assets/imgs/list-empty.png')"
      :description="description"
    />
  </div>
</template>

<script>
import CaseItem from './components/caseItem.vue';
export default {
  name: 'case-list',
  components: {
    CaseItem
  },
  data() {
    return {
      caseList: [],
      loading: false,
      finished: true,
      description: '暂无病历记录'
    };
  },
  async created() {
    await this.onLoad();
  },

  methods: {
    async onLoad() {
      try {
        await this.fetchData();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    async fetchData() {
      const res = await this.$fetch.fetchGetMedicalMember({});
      this.caseList = res || [];
      this.finished = true;
    }
  }
};
</script>

<style lang="less" scoped>
.case-list {
  padding: 10px 16px;
}
</style>
